import { type PropsWithChildren, useEffect } from "react";
import { OpenFeatureProvider } from "@openfeature/react-sdk";
import { InMemoryProvider, OpenFeature } from "@openfeature/web-sdk";

import { useFeatureFlagsSuspense } from "../services/features/feature-flags";

export function FeatureFlagsProvider({ children }: PropsWithChildren) {
  const { data: flags } = useFeatureFlagsSuspense();

  useEffect(() => {
    OpenFeature.setProvider(new InMemoryProvider(flags));
  }, [flags]);

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
}
